import LoginModel                 from "./login-model";
import LoginPageView              from "./login-page-view";
import LoginBaseView              from "./login-base-view";
import LoginBaseModel             from "./login-base-model";
import Translator                 from 'bazinga-translator';
import Axios                      from "../commun/axiosInstance";
import ResetExtranetPasswordModel from "./reset-extranet-password-model";
import ResetExtranetPasswordView  from "./reset-extranet-password-view";
import LoginOtpView               from "./login-otp-view";
import LoginOtpModel              from "./login-otp-model";


export function initLoginViewModel({modelData, translationUrl})
{
    return Axios.get(translationUrl).then((reponse) => {
        Translator.fromJSON(reponse.data);
        const $el = $('div#loginbox');

        const model = new LoginModel(modelData);
        const view =  new LoginPageView({ model, el: $el });
        view.render();

        return view;
    });
}

export function initResetExtranetPasswordViewModel({modelData})
{
    const $el = $('div#loginbox');

    const model = new ResetExtranetPasswordModel(modelData);
    const view =  new ResetExtranetPasswordView({ model, el: $el });
    view.render();
}

export function initLoginBaseViewModel({modelData, translationUrl})
{
    return Axios.get(translationUrl).then((reponse) => {
        Translator.fromJSON(reponse.data);
        const $el = $('div#loginbox');

        const model = new LoginBaseModel(modelData);
        const view =  new LoginBaseView({ model, el: $el });
        view.render();

        return view;
    });
}

export function initLoginOTPViewModel({modelData, translationUrl})
{
    return Axios.get(translationUrl).then((reponse) => {
        Translator.fromJSON(reponse.data);
        const $el = $('div#loginbox');

        const model = new LoginOtpModel(modelData);
        const view =  new LoginOtpView({ model, el: $el });
        view.render();

        return view;
    });
}